const errorRouter = [
    /**
     * 流程管理
     **/
    {
        path: '/error/developing',
        meta: { title: '网站开发中' },
        component: () => import('@/views/system/errorpage/developing'),
        used: true,
    },
]

export default errorRouter
